import { Button, Form, FormGroup, Modal, NumberInput } from '@ksyos/design-system';
import { useState } from 'react';
import { translateKey } from '@frontend/translate';

interface IEditMaxGradingsModalProps {
    isOpen: boolean;
    maxGradingsPerDay: number | null;
    maxGradingsPerMonth: number | null;
    onCancel: () => void;
    onSave: (maxGradingsPerDay: number | null, maxGradingsPerMonth: number | null) => void;
}

export function EditMaxGradingsModal(props: IEditMaxGradingsModalProps) {
    const [maxGradingsPerDay, setMaxGradingsPerDay] = useState(props.maxGradingsPerDay);
    const [maxGradingsPerMonth, setMaxGradingsPerMonth] = useState(props.maxGradingsPerMonth);

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onCancel}
            size="medium"
        >
            {<Modal.Header>{translateKey('serviceGraderPool.editMaximumGradings')}</Modal.Header>}
            <Modal.CloseButton />
            <Modal.Body>
                <Form submitOnEnter={false}>
                    <FormGroup label={translateKey('serviceGraderPool.perDay')}>
                        <NumberInput
                            label="maxGradingsPerDay"
                            onChange={setMaxGradingsPerDay}
                            value={maxGradingsPerDay}
                        ></NumberInput>
                    </FormGroup>
                    <FormGroup label={translateKey('serviceGraderPool.perMonth')}>
                        <NumberInput
                            label="maxGradingsPerMonth"
                            onChange={setMaxGradingsPerMonth}
                            value={maxGradingsPerMonth}
                        ></NumberInput>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <>
                    <Button
                        onClick={props.onCancel}
                        type="button"
                        variant="outline"
                    >
                        {translateKey('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => props.onSave(maxGradingsPerDay, maxGradingsPerMonth)}
                        type="button"
                        variant="solid"
                    >
                        {translateKey('common.save')}
                    </Button>
                </>
            </Modal.Footer>
        </Modal>
    );
}
